import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import parse from "html-react-parser";
import Content from "../../blocks/Content";


export default function DemoCourseSet({courseSet,handleChangeContent})
{
    const [demoSetCourses, setDemoSetCourses] = useState([]);   
    useEffect(() => {
        setDemoSetCourses(courseSet);        
    }, [courseSet]);

    function renderDemoSet(){
        return <Row className={"ScreenCabinet-Row"} style={demoSetCourses.length<3?{width:"50%",margin:"auto"}:{}}>
            { demoSetCourses.map((course, index,courses)=>{
            return <Col xs={"12"} lg={courses.length>3?"6":"12"} className={"ScreenCabinet-Col ModuleCard cursor-pointer"} key={index}>
                    <div onClick={() => handleChangeContent("Course",course.uuid,"")}
                            className={"ModuleCard-Link d-flex align-items-center justify-content-center Btn Btn_darken text-white text-center p-5"}>
                        <div className="ModuleCard-Text d-flex" >                                                
                            {parse(course.title)}
                        </div>
                    </div>
                          
                </Col>
            })}
        </Row>
    }

    return <div className={"Screen ScreenCabinet container"}>
        <Content>
                        {renderDemoSet()}</Content></div>
    
}